(() => {
  const threshold = 9350;
  const shopAll = '/collections/shop-all';
  const newIn = '/collections/new-in';
  let timer;

  const money = (cents) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: cents % 100 ? 2 : 0,
  }).format(cents / 100);

  function emptyState(container, drawer = false) {
    if (!container || container.dataset.tscEmptyEnhanced) return;

    const heading = container.querySelector('.cart__empty-text, h1, h2');
    if (heading) heading.textContent = 'Your cart is ready when you are.';

    if (!container.querySelector('.tsc-empty-copy')) {
      const copy = document.createElement('p');
      copy.className = 'tsc-empty-copy';
      copy.textContent = 'Start with one versatile piece, then build from there.';
      heading ? heading.after(copy) : container.prepend(copy);
    }

    if (!container.querySelector('.tsc-empty-actions')) {
      const actions = document.createElement('div');
      actions.className = 'tsc-empty-actions';
      actions.innerHTML = `
        <a class="button" href="${shopAll}">Shop All</a>
        <a class="button button--secondary" href="${newIn}">Explore New In</a>
      `;
      const oldButton = container.querySelector('a.button');
      oldButton ? oldButton.replaceWith(actions) : container.append(actions);
    }

    container.querySelectorAll(
      '.cart-drawer__collection, .cart__login-title, .cart__login-paragraph'
    ).forEach((element) => { element.style.display = 'none'; });

    if (drawer) container.closest('.cart-drawer__warnings')?.classList.add('tsc-cart-empty-ready');
    container.dataset.tscEmptyEnhanced = 'true';
  }

  function enhanceEmptyStates() {
    emptyState(document.querySelector('#CartDrawer .cart-drawer__empty-content'), true);
    emptyState(document.querySelector('cart-items .cart__warnings'));

    document.querySelectorAll('a[href*="javascript:history.back"]').forEach((link) => {
      link.href = shopAll;
      link.textContent = 'Shop All';
    });
  }

  function headings() {
    const drawer = document.querySelector('#CartDrawer .drawer__heading');
    const page = document.querySelector('cart-items .title--primary');
    if (drawer) drawer.textContent = 'Your Cart';
    if (page) page.textContent = 'Your Cart';
  }

  function viewCart(target) {
    if (!target || target.querySelector('[data-tsc-view-cart]')) return;
    const link = document.createElement('a');
    link.href = window.routes?.cart_url || '/cart';
    link.className = 'tsc-cart-view-link';
    link.dataset.tscViewCart = '';
    link.textContent = 'View Cart';
    (target.querySelector('.cart__ctas') || target).after(link);
  }

  function shippingState(cart) {
    if (cart.currency !== 'USD') {
      return {
        signature: `${cart.currency}:${cart.item_count}`,
        label: '<strong>Free U.S. shipping</strong><span>On qualifying orders</span>',
        progress: 0,
      };
    }

    const hasLookBundle =
      Array.isArray(cart.items) &&
      cart.items.some((item) => Number(item.product_id) === 9195261624494) &&
      cart.items.some((item) => Number(item.variant_id) === 48910787051694);

    if (hasLookBundle) {
      return {
        signature: `USD:look:${cart.total_price}:${cart.item_count}`,
        label: '<strong>Free U.S. shipping unlocked</strong><span>Complete the Look offer</span>',
        progress: 100,
      };
    }

    const hasEarringsBundle =
      Array.isArray(cart.items) &&
      cart.items.some((item) => Number(item.product_id) === 9195261624494) &&
      cart.items.some((item) => Number(item.variant_id) === 48915080183982);

    if (hasEarringsBundle) {
      return {
        signature: `USD:earrings:${cart.total_price}:${cart.item_count}`,
        label: '<strong>Free U.S. shipping unlocked</strong><span>Dress + earrings offer</span>',
        progress: 100,
      };
    }

    const remaining = Math.max(threshold - cart.total_price, 0);
    return {
      signature: `USD:${cart.total_price}:${cart.item_count}`,
      label: remaining
        ? `<strong>${money(remaining)} away</strong><span>from free U.S. shipping</span>`
        : '<strong>Free U.S. shipping unlocked</strong><span>Threshold reached</span>',
      progress: Math.min(Math.round((cart.total_price / threshold) * 100), 100),
    };
  }

  function progress(target, cart) {
    if (!target || !cart.item_count) return;
    const state = shippingState(cart);
    let block = target.querySelector(':scope > [data-tsc-shipping-progress]');

    if (!block) {
      block = document.createElement('div');
      block.className = 'tsc-cart-progress';
      block.dataset.tscShippingProgress = '';
      block.innerHTML = `
        <div class="tsc-cart-progress__label"></div>
        <div class="tsc-cart-progress__track" aria-hidden="true">
          <div class="tsc-cart-progress__bar"></div>
        </div>
      `;
      target.prepend(block);
    }

    if (block.dataset.signature !== state.signature) {
      block.dataset.signature = state.signature;
      block.querySelector('.tsc-cart-progress__label').innerHTML = state.label;
      block.style.setProperty('--tsc-cart-progress', `${state.progress}%`);
    }
  }

  function assurance(target) {
    if (!target || target.querySelector(':scope > [data-tsc-cart-assurance]')) return;
    const element = document.createElement('div');
    element.className = 'tsc-cart-assurance';
    element.dataset.tscCartAssurance = '';
    element.innerHTML = '<span>Tracked delivery</span><span>Secure checkout</span>';
    target.append(element);
  }

  async function refresh() {
    headings();
    enhanceEmptyStates();

    try {
      const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      const drawerFooter = document.querySelector('#CartDrawer .drawer__footer');
      const cartBlocks = document.querySelector('#main-cart-footer .cart__blocks');

      progress(drawerFooter, cart);
      progress(cartBlocks, cart);

      if (cart.item_count) {
        assurance(drawerFooter);
        assurance(cartBlocks);
        viewCart(drawerFooter);
      }
    } catch (error) {
      console.debug('Cart enhancement unavailable', error);
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 160);
  }

  function observe(target) {
    if (!target || target.dataset.tscCartObserved) return;
    target.dataset.tscCartObserved = 'true';
    new MutationObserver(schedule).observe(target, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function init() {
    refresh();
    observe(document.querySelector('#CartDrawer'));
    observe(document.querySelector('cart-items'));
    observe(document.querySelector('#main-cart-footer'));
    document.addEventListener('cart:refresh', schedule);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init, { once: true })
    : init();
})();